
const NavImage = () => {
  return (
    <>
    <img src={`home/images/logo_name.png?${new Date().getTime()}`}  style={{maxWidth:'29%'}} />
    {/* <h4 style={{whiteSpace:'nowrap',fontSize:'23px'}}><span style={{color:'#f4550e'}}>Mumbai</span> <span style={{color:'#5cc601'}}>Matka</span></h4> */}
    </>
  );
};

export default NavImage;